var _module_exports = "<i aria-hidden=\"true\" ng-class=\"['status-indicator', { ok: $ctrl.ok }]\"></i>\n";;
var path = 'app/core/components/status-indicator/status-indicator.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;